import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Header } from '../comp/Header'
import { ShoppingCart as ShoppingCartIcon, MapPin, Clock, Award, Users, Shield, Wrench, CheckCircle } from 'lucide-react'
import { Button } from '../Components/ui/button'
import { ImageWithFallback } from '../Components/figma/ImageWithFallback'
import { CartItem, ShoppingCart } from '../comp/ShoppingCart'
import Cookies from 'js-cookie'
import { catalogClient } from '../services/grpc'
import * as pb from '../generated/catalog_pb';
import { NewHeader } from '../comp/NewHeader'
import { Footer } from '../comp/Footer';
import Logo from "../comp/icons/Logo"
export function AboutPage() {
  const [isCartOpen, setIsCartOpen] = useState(false)
 const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [cartItemCount, setCartItemCount]= useState(0);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');

const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const initializeApp = async () => {
    let isguid = Cookies.get('guid');
    if (typeof isguid != 'string') {
      const req= new pb.guidReq();  
     
      req.setIp(window.location.hostname);
      catalogClient.getGuid(req, {}, (err, response) => {
        if (err) {
          console.error('Error fetching guid:', err.code, err.message);
        } else {
          Cookies.set('guid', response.getGuid());
        }
      });
    }
    const guid = Cookies.get('guid');
   
    };
    const updateQuantity = (porodId: number, quantity: number,storage:string) => {
          try {
            if (quantity === 0) {
              removeFromCart(porodId,storage)
              return
            }
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
              const req = new pb.CartAddReq();
              req.setGuid(guid);
              req.setProductId(porodId);
              req.setQty(quantity);
              req.setStorage(storage);
              catalogClient.cartUpdate(req, {}, (err, response) => {
                if (err) {
                  console.error('Error adding to cart:', err.code, err.message);
                }
              });
            }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.map(item =>
                item.product.id === porodId  && item.storage === storage? { ...item, quantity,storage } : item
              )
            })
          } catch (error) {
            console.error('Error updating quantity:', error)
          }
        }
       
        const removeFromCart = (porodId: number,storage:string) => {
          try {
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
            const req = new pb.CartRemoveReq();
            req.setGuid(guid);
            req.setProductId(porodId);
            req.setQty(0);
            req.setStorage(storage);
            catalogClient.cartRemove(req, {}, (err, response) => {
              
              if (err) {
                console.error('Error removing from cart:', err.code, err.message);
              }
            });
          }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.filter(item => !(item.product.id === porodId && item.storage === storage))
            })
          } catch (error) {
            console.error('Error removing from cart:', error)
          }
        }
        
          const setOrder = ()=>{
              if (!customerName || !customerPhone) {
                setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
                return;
            }
          
              const guid = Cookies.get('guid');
              if (typeof guid === 'string') {
                const req=new pb.OrderAcceptReq();
                req.setGuid(guid);
                req.setName(customerName);
                req.setPhone(customerPhone);
                catalogClient.orderAccept(req, {}, (err, response) => {
                  if (err) {
                    console.error('Error removing from cart:', err.code, err.message);
                  } else {
                  if (response.getStatus()=="fail") { 
                    setAlertMessage(`${response.getMessage()}`);
                  } else {
                    setAlertMessage(`Спасибо за заказ.\n\ 
                      В ближайшее время наш менеджер свяжется с Вами.\n\ 
                      Номер вашего заказа: ${response.getNum()}`);
                    setCartItems([]);
                    setIsCartOpen(false);
                  }
                    return;
                  }
                });
              }
            }
          const OnsetIsInCartStorage=(items:string[])=>{
 
  }
  return (
    <div className="min-h-screen bg-gray-50">
        <NewHeader
           cartItemCount={cartItemCount}
           onCartClick={() => setIsCartOpen(true)}
           onAccountClick={() => setIsAccountOpen(true)}
           searchQuery={searchQuery}
           onSearchChange={setSearchQuery}
           page='about'
         />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl mb-6">О Компании "YUTONG ORIGINAL"</h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
             "YUTONG ORIGINAL" – компания по продаже качественных, оригинальных запчастей для автобусов Yutong. 
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-4">
           <img 
              src="https://cdn.yutongoriginal.ru/images/yutongaboutbanner.jpg"
              alt="YUTONG ORIGINAL" 
              className="w-full object-cover"
            />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl mb-6">О нас</h2>
              <p className="text-gray-700 mb-4">
              Yutong Original — это не рядовой магазин, а официальный портал с оригинальными запчастями для автобусов Yutong. Мы сотрудничаем напрямую с заводом-производителем, поэтому каждая деталь, которую вы покупаете, имеет заводской номер, сертификат качества и подтверждённую подлинность.
              </p>
              <p className="text-gray-700 mb-4">       
              Почему мы не продаём заменители? Потому что автобусы Yutong строят по своим чертежам, а не чужим. Каждый миллиметр и болт рассчитаны инженерной командой. 
              Если заменить оригинальные детали на похожие, вы можете сэкономить сейчас, но потерять качество и безопасность в будущем. 
              Для нас важна безопасность пассажиров и надёжность вашего транспорта.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-blue-600">7500+</div>
                <div className="text-gray-600">Уникальных автозапчастей</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-blue-600">1000 м2</div>
                <div className="text-gray-600">Площадь склада</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-blue-600">165000+ </div>
                <div className="text-gray-600">Автозапчастей на складах</div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="text-4xl mb-2 text-blue-600">8</div>
                <div className="text-gray-600">Складов по всей России</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl mb-4">Почему стоит выбрать именно нас?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
               Мы — не просто продавцы автозапчастей, а ваши помощники в вопросах безопасности и надежности автобуса.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 bg-opacity-10 rounded-full mb-4">
                 <img 
              src="https://cdn.yutongoriginal.ru/images/minilogo.png"
              alt="YUTONG ORIGINAL" 
              className="h-8  object-cover"
            />
              </div>
              <h3 className="text-xl mb-3">Качество</h3>
              <p className="text-gray-600">             
                  У нас вы найдете только оригинальные детали Yutong.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 bg-opacity-10 rounded-full mb-4">
                       <img 
              src="https://cdn.yutongoriginal.ru/images/minilogo.png"
              alt="YUTONG ORIGINAL" 
              className="h-8  object-cover"
            />
              </div>
              <h3 className="text-xl mb-3">Профессиональная команда</h3>
              <p className="text-gray-600">
                  Наши специалисты сертифицированы и имеют большой опыт. Они регулярно повышают квалификацию и помогут подобрать нужные запчасти.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 bg-opacity-10 rounded-full mb-4">
                       <img 
              src="https://cdn.yutongoriginal.ru/images/minilogo.png"
              alt="YUTONG ORIGINAL" 
              className="h-8  object-cover"
            />
              </div>
              <h3 className="text-xl mb-3">Гарантия разумной цены</h3>
              <p className="text-gray-600">             
                    Мы стараемся предложить оптимальное соотношение цены и качества, учитывая ваши нужды.
              </p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 bg-opacity-10 rounded-full mb-4">
                       <img 
              src="https://cdn.yutongoriginal.ru/images/minilogo.png"
              alt="YUTONG ORIGINAL" 
              className="h-8  object-cover"
            />
              </div>
              <h3 className="text-xl mb-3">Логистика из Китая</h3>
              <p className="text-gray-600">
                    Мы берём на себя все вопросы доставки вашей покупки прямо с завода.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Physical Locations */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 rounded-xl overflow-hidden">
            <img 
              src="https://cdn.yutongoriginal.ru/images/i-_2_.jpg"
              alt="Склад YUTONG ORIGINAL" 
              className="w-full  object-cover"
            />
          </div>

          {/* Showroom Images Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="rounded-xl overflow-hidden">
              <img 
                src="https://cdn.yutongoriginal.ru/images/i-_3_.jpg"
                alt="Склад YUTONG ORIGINAL" 
                className="w-full  object-cover"
              />
            </div>

            <div className="rounded-xl overflow-hidden">
              <img 
                src="https://cdn.yutongoriginal.ru/images/i-_5_.jpg"
                alt="Склад YUTONG ORIGINAL" 
                className="w-full  object-cover"
              />
             
            </div>
             <div className="bg-white p-6">
                <h3 className="text-xl mb-2"> </h3>
                <p className="text-gray-600">            
                    
                </p>
              </div>
          </div>

          {/* Location Details */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <MapPin className="h-8 w-8 text-blue-600 mb-4" />
              <h3 className="text-xl mb-3">Мы находимся</h3>
              <p className="text-gray-600 mb-2"> Предпортовая ул., 8Т, склад № 17 </p>
              <p className="text-gray-600 mb-2">Санкт-Петербург</p>
              <p className="text-gray-600 mb-2">
                <a href="https://yandex.ru/maps/org/yutong_original/23614169771/?ll=30.301800%2C59.834619&z=16" className="inline-flex items-center" >
                  <img 
                    src="https://cdn.yutongoriginal.ru/images/yanavigator.png"
                    alt="Навигатор" 
                    className="object-cover" width="50"/> Мы на карте</a></p>
              <p className="text-blue-600">+7 (981) 965-68-88</p>
              
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <Clock className="h-8 w-8 text-blue-600mb-4" />
              <h3 className="text-xl mb-3">Часы работы</h3>
              <p className="text-gray-600 mb-1">Понедельник-Пятница: 10:00–19:00</p>
              <p className="text-gray-600">Суббота-Воскресенье: Выходной</p>
            </div>

          </div>
        </div>
      </section>



       <Footer/>
       {Array.isArray(cartItems) && (
                          <ShoppingCart
                            isOpen={isCartOpen}
                            onOpenChange={setIsCartOpen}
                            cartItems={cartItems}
                            onUpdateQuantity={updateQuantity}
                            onRemoveItem={removeFromCart}
                            onOrder={setOrder}
                            customerName={customerName}
                            customerPhone={customerPhone}
                            setCustomerName={setCustomerName}
                            setCustomerPhone={setCustomerPhone}
                            setCartItemCount={setCartItemCount}
                            setIsInCartStorage={OnsetIsInCartStorage}
                          />
                        )}
    </div>
  )
}
